import { render } from "./DocContent.vue?vue&type=template&id=63eb20a6&scoped=true&ts=true"
import script from "./DocContent.vue?vue&type=script&lang=ts"
export * from "./DocContent.vue?vue&type=script&lang=ts"

import "./DocContent.vue?vue&type=style&index=0&id=63eb20a6&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eb20a6"]])

export default __exports__